export const ERP_PROVIDER_IDS = [
  "dynamics_business_central",
  "hubspot",
  "salesforce",
  "epicor",
  "prophet21",
  "jobboss2",
  "odyssey",
  "eniteo",
  "fake_erp",
] as const;

export type ERPProviderKey = (typeof ERP_PROVIDER_IDS)[number];
